// Warn if overriding existing method
if(Array.prototype.og_equals)
  console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.og_equals = function (array) {
  // if the other array is a falsy value, return
  if (!array)
    return false;

  // compare lengths - can save a lot of time 
  if (this.length != array.length)
    return false;

  for (var i = 0, l=this.length; i < l; i++) {
    // Check if we have nested arrays
    if (this[i] instanceof Array && array[i] instanceof Array) {
      // recurse into the nested arrays
      if (!this[i].equals(array[i]))
        return false;       
    }           
    else if (this[i] != array[i]) { 
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;   
    }           
  }       
  return true;
}

// Hide method from for-in loops
Object.defineProperty(Array.prototype, "og_equals", {enumerable: false});

var selected_variant_id = false;

$('.nutrition-ingredient-information-tabs span').click(function(){
  let parent = $(this).parents('.nutrition-ingredient-information-modal');
  parent.find('.nutrition-ingredient-information-contents > div').eq($(this).index()).show().siblings().hide();
  $(this).addClass('active').siblings().removeClass('active');
});

$('.nutrition-ingredient-information-tabs').each(function(){
  $(this).find('span').first().click();
})

// NUTRITION AND INGREDIENTS MODAL NEW

$('.nutrition-and-ingredients-tabs span').click(function(){
  let parent = $(this).parents('.nutrition-and-ingredients-modal');
  parent.find('.nutrition-and-ingredients-contents > div').eq($(this).index()).show().siblings().hide();
  $(this).addClass('active').siblings().removeClass('active');
});

$('.nutrition-and-ingredients-tabs').each(function(){
  $(this).find('span').first().click();
});

$('#cart_form .product_group_body .product_group.free_product .product_group_product_button a.button, .free-product-popup-overlay, .free-product-popup-close').click(function(e){
  e.preventDefault();
  $('html').toggleClass('free-product-popup-open');
  return false;
});

$('.fpp-variant.fpp-product-selector .fpp-variant-options > div').click(function(){
  $(this).addClass('active').siblings().removeClass('active');
});

$('.fpp-product-options > div').click(function(){
  $(this).addClass('active').siblings().removeClass('active');
  let product_id = $(this).attr('product-id');
  if(product_id != ''){
    $('.fpp-product-variants div[product-id="' + product_id + '"]').show().siblings().hide();
  }
  fpp_validate_variants();
});

$('.fpp-product-options > div').first().click();

$('.fpp-variant-options > input').change(function(){
  fpp_validate_variants();
});

function fpp_validate_variants() {
  $('.fpp-button-container .button').prop('disabled', true);
  var selected_product = $('.fpp-product-options div[class="active"]');
  if(selected_product.length == 0){
    return false;
  }
  var selected_product_id = selected_product.attr('product-id');
  if(selected_product_id == undefined || selected_product_id == ''){
    return false;
  }
  if(free_products[selected_product_id] == undefined){
    return false;
  }
  var selected_variants = [];
  selected_variant_id = false;
  $('.fpp-variants[product-id="' + selected_product_id + '"] .fpp-variant-options input[type="radio"]:checked').each(function(){
    selected_variants.push($(this).val());
  });
  if(free_products[selected_product_id].variants.length > 1){
    for( let i in free_products[selected_product_id].variants) {
      let variant = free_products[selected_product_id].variants[i];
      if(variant.options != undefined && variant.available == true){
        if(variant.options.og_equals(selected_variants)){
          selected_variant_id = variant.id;
        }
      }
    }
  }else {
    selected_variant_id = free_products[selected_product_id].variants[0].id;
  }
  if(selected_variant_id){
    $('.fpp-button-container .button').prop('disabled', false);
  }
}

const hasFreeTshirtInCartItems = $('.product_group.container.free-tshirt-container').length === 1;
const hasFreeTshirtInLocalStorage = localStorage.getItem("hasFreeTshirt") === 'true';


// if (!hasFreeTshirtInCartItems && hasFreeTshirtInLocalStorage) {
//   setTimeout(() => {
//     location.reload();
//   }, 500)
// }

if (hasFreeTshirtInCartItems && hasFreeTshirtInLocalStorage) {
  $('#free-tshirt-button-cart').addClass('hidden');
  $('#free-tshirt-added-cart').removeClass('hidden');
} else {
  $('#free-tshirt-button-cart').removeClass('hidden');
  $('#free-tshirt-added-cart').addClass('hidden');
}

$('.fpp-button-container .button').click(function(e){
  var enable_val = $(this).closest(".product_group_body").find(".product_group[product-id='7537732387054']").attr('product-id');
  if(enable_val){
    localStorage.setItem("hasFreeTshirt", true);
    window.location.href = window.location.href + '?item=' + selected_variant_id;

  }else{
    var items = [];
    var self = this;
    $(self).addClass('loading');
    items.push({id: selected_variant_id, quantity: 1});
    console.log('Items: '+ items);
    jQuery.ajax({
      type: 'POST',
      url: window.Shopify.routes.root + 'cart/add.js',
      data: {items: items},
      dataType: 'json',
      success: function(e) { 
        
        $("#cart_form .product_group_body .product_group.free_product").hide();
        setTimeout(function(){
          $(self).removeClass('loading');
          $(self).addClass('loaded');
          localStorage.setItem("hasFreeTshirt", true);
          location.reload();
        }, 2000);
      },
      error: function(e){
        // console.log('error');
        // $(self).removeClass('loading');
        // $(self).addClass('loaded');
        // setTimeout(function(){
        //  location = window.Shopify.routes.root + 'cart';
        // }, 1000);
      }
    });
  }
});

$(document).ready(function() {    
  $('.free_product a.no-thanks-link').click(function() {
    $('.product_group.free_product').hide();
  });
});

$('.product_group_body .remove-product').click(function(e){
  e.preventDefault();
  var items = {};
  var self = this;
  var parent = $(self).parents('.product_group');
  var ref_price = parent.find('.order-type-cell .desktop-price').text().split(" ")[0];
  var price = ref_price.split(" ")[0];
  var subtotal = $('.cart__subtotal span.money').text().trim();
  var total = subtotal.split(" ")[0];
  var cur_icon = subtotal.split(" ")[1];
  if(price == 'free'){ }else{
    var final_price =  total - price + ' ' + cur_icon;  
    var floatPrice = parseFloat(final_price).toFixed(2);
  }
  parent.find('.product_group_variants span').each(function(){
    var variant_id = $(this).attr('variant-id');
    if(variant_id != undefined || variant_id != '') {
      items[variant_id] = 0
    }
  });
  if(Object.keys(items).length){
    $(self).text('Removing...');
    console.log('Ajex');
    jQuery.ajax({
      type: 'POST',
      url: window.Shopify.routes.root + 'cart/update.js',
      data: {updates: items},
      dataType: 'json',
      success: function(e) { 
        $('.cart__subtotal span.money').text(floatPrice);   
        if (price == 'free') {
          localStorage.setItem("hasFreeTshirt", false);
        }
        console.log(items);
        parent.remove();
        //location = window.Shopify.routes.root + 'cart';
      },
      error: function(e){
        console.error(e);
      }
    });
  }
  return false;
});

const clearBasket = () => {
  fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST',
    data: '',
    dataType: 'json'
  })
  .then(response => {
    localStorage.setItem("hasFreeTshirt", false);
    location.reload();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

$('.clear-basket').click(function(e){
  e.preventDefault();
  clearBasket();
  clearBasket();
});

$('.remove_variation').click(function(){
  var $t = $(this);
  var v_price = $(this).closest("span").attr("variant-price").trim();
  var variant_id = $(this).closest("span").attr("variant-id");
  var quantity_val = $(this).closest("span").attr("variant-quantity");
  var items = [];
  var data = { updates: {} };
  data.updates[variant_id] = 0;   
  var variation_total = v_price.split(" ")[0];
  if (quantity_val > 1){
    variation_total = variation_total * quantity_val;
  }else{
    variation_total = variation_total * quantity_val;
  }
  var subtotal = $('.cart__subtotal span.money').text().trim();
  var total = subtotal.split(" ")[0];
  var cur_icon = subtotal.split(" ")[1];
  var final_price =  total - variation_total + ' ' + cur_icon;  
  var updated_price = parseFloat(final_price).toFixed(2) + ' ' + cur_icon;
  var tab_subtotal = $(this).closest(".product_group").find('.desktop-price').text().trim();
  var tab_total = tab_subtotal.split(" ")[0];
  var tab_cur_icon = tab_subtotal.split(" ")[1];
  var tab_final_price =  tab_total - variation_total + ' ' + tab_cur_icon;  
  var tab_updated_price = parseFloat(tab_final_price).toFixed(2) + ' ' + tab_cur_icon;
  var quantity = $t.closest(".product_group").find('.product_quantity').text();
  console.log('quantity', quantity)  
  var update_quantity = quantity - quantity_val;
  console.log('update_quantity', update_quantity) 
  jQuery.ajax({
    type: 'POST',
    url: window.Shopify.routes.root + 'cart/update.js',
    data: data,
    dataType: 'json',
    success: function(e) { 
      if (update_quantity == 0){
        console.log('Remove product row'); 
        $t.closest(".product_group").css("display", "none"); 
      }
      console.log('success');
      $t.closest("span").addClass("except");
      $t.closest("span").css("display", "none"); 
      $('.cart__subtotal span.money').text(updated_price); 
      $t.closest(".product_group").find('.desktop-price').text(tab_updated_price);
      $t.closest(".product_group").find('.x-mobile-price').find('span').text(tab_updated_price);
      $t.closest(".product_group").find('.mobile-quantity').find('span').text(update_quantity);
      $t.closest(".product_group").find('.product_quantity').text(update_quantity);
    },
    error: function(e){
      console.log('error');
    }
  });
});

$(document).on("click", '.product_group.container[product-id~="7537732387054"] a.cart__remove-btn', function(event) { 
  setTimeout(function() {
    localStorage.setItem("hasFreeTshirt", false);
    location.reload();
  }, 1000);
});

$(document).ready(function() {
  $('.rmv-rfrsh a').on('click', function() {
    setTimeout(function(){
      localStorage.setItem("hasFreeTshirt", false);
      location = window.Shopify.routes.root + 'cart';
    }, 1000);
  });
  var numberOfFreeItems = $('.free-item').length;
  var numberOfFreeItemsindex = '';
  if(numberOfFreeItems === 1){
    numberOfFreeItemsindex = 2;
  }else if(numberOfFreeItems === 2){
    numberOfFreeItemsindex = 3;
  }
  if ($('.product_group').hasClass('free-item')) {
    $(document).on("click", '#cart_form .item__remove .cart__actual_item', function(event) { 
      console.log('removing free item xxx')
      var updateData = {};
      var quantity = "0";
      var group = $(".product_group");
      group.find(".product_group_variants span").each(function () {
        var variant_id = $(this).attr("variant-id");
        if (variant_id != undefined || variant_id != "") {
          updateData[variant_id] = 0;
        }
      });
      jQuery.ajax({
        type: 'GET',
        url: 'cart.js',
        dataType: 'json',
        success: function(response) {
          if(response.items.length === numberOfFreeItems) {
            jQuery.ajax({
              type: "POST",
              url: window.Shopify.routes.root + "cart/update.js",
              data: {
                updates: updateData,
              },
              dataType: "json",
              success: function (e) {
                console.log('deleting free item')
                localStorage.setItem("hasFreeTshirt", false);
                location = window.Shopify.routes.root + "cart";
              },
              error: function (e) {
                console.log(e);
                localStorage.setItem("hasFreeTshirt", false);
                location = window.Shopify.routes.root + "cart";
              },
              async: false, // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
            });                
          }else{
            console.log('inside else', response.item_count)
          }
        }
      });  
    });
  }  
});

$(document).ready(function() {
  $('.product_group.container.other a.cart__remove-btn').on('click', function() {
    var count_elements = $('.product_group.container.other').length;
    if ($("#cart_form .product_group_body .product_group").hasClass("free")) {
      if(count_elements == 1){
        var updateData = {};
        var quantity = '0';
        var group = $('.product_group');
        group.find('.product_group_variants span').each(function(){
          var variant_id = $(this).attr('variant-id');
          if(variant_id != undefined || variant_id != '') {
            updateData[variant_id] = 0;
          }
        });
        jQuery.ajax({
          type: 'POST',
          url: window.Shopify.routes.root + 'cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          success: function(e) { 
            setTimeout(function(){
              localStorage.setItem("hasFreeTshirt", false);
              location = window.Shopify.routes.root + 'cart';
            }, 500);
          },
          async:false,  // Be warned, async:false has been deprecated in jQuery for a long time and is not recommended for use. It's generally recommended to use callbacks or promises instead
        });
      }
    }    
  });
});

// theme JS

$(window).ready(function() {
  setInterval(function(){ 
    $( "div#multivariants_setbox_header" ).appendTo( $( "div#multivariants_setbox_body" ) );
  }, 3000);
});

$(document).ready(function(){
  $('.announcement-bar__content-slider').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    adaptiveHeight: true,
    pageDots: false,
    autoPlay: true,
    wrapAround: true
  });
  $(function() {
    $('.tabs-nav a').click(function() {
      // Check for active
      $(this).parent().parent().find("li").removeClass('active');
      $(this).parent().addClass('active');
      // Display active tab
      let currentTab = $(this).attr('href');        
      $(this).parent().parent().parent().parent().find(".content-tab").hide();
      $(this).parent().parent().parent().parent().find(currentTab).show();
      return false;
    });
  });
  jQuery(window).on("resize", function (e) {
    checkScreenSize();
  });
  function checkScreenSize(){
    var newWindowWidth = $(window).width();
  }
});

$(window).ready(function() {
  const thirdPartReviewsCount = $('.third-party-reviews__review').length;
  
  if (thirdPartReviewsCount > 1) {
    $('.third-party-reviews__review').append('<div></div>');

    $('.third-party-reviews__container').flickity({
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: true,
      contain: false,
    });
  }
});